/*
  英语
*/
export default {
  BatchSearch: {
    SearchingForOrderId: 'Searching for order id',
    Select: 'Select'
  },
  BatchSearchOne: {
    SearchingForID: 'Searching for ID'
  },
  IssuedDetailsDialog: {
    BillingInformation: 'Billing Information',
    BillID: 'Bill ID',
    AwaitingPayment: 'Awaiting Payment',
    BillsAmount: 'Bills Amount',
    PaymentAmount: 'Payment Amount',
    PaidAmount: 'Paid Amount',
    OrderID: 'Order ID',
    ParcelCode: 'Parcel Code',
    TableColumnPaidAmount: 'Paid Amount',
    DeliveryTime: 'Delivery time',
    PaymentDate: 'Payment Date',
    Status: 'Status',
    Shippped: 'Shippped'
  },
  PaymentDialog: {
    PayNow: 'Pay Now',
    PaymentAmount: 'Payment Amount',
    PleaseSelectYourPaymentMethod: 'Please select your payment method',
    Paypal: 'Paypal',
    CreditCard: 'Credit Card',
    Balance: 'Balance',
    Others: 'Others',
    ButtonPayNow: 'Pay Now'
  },
  Billing: {
    BillingStatement: 'Billing Statement',
    Bills: 'Bills',
    IncomingBills: 'Incoming Bills',
    Issued: {
      Status: 'Status',
      WaitingPayment: 'Waiting Payment',
      PaymentProcessing: 'Payment Processing',
      Paid: 'Paid',
      StartDate: 'Start Date',
      EndDate: 'End Date',
      Selected: 'Selected',
      PayNow: 'Pay Now',
      ID: 'ID',
      BillsAmount: 'Bills Amount',
      PaymentAmount: 'Payment Amount',
      TableColumnStatus: 'Status',
      PaymentDate: 'Payment Date',
      CreateDate: 'Create Date',
      ViewDetails: 'View Details',
      TableColumnPayNow: 'Pay Now',
      NoRecord: 'No Record',
      Action: 'Action'
    },
    Unpublished: {
      ParcelStatus: 'Parcel Status',
      shipped: 'shipped',
      completed: 'completed',
      Select: 'Select',
      PaymentTime: 'Payment Time',
      DeliveryTime: 'Delivery Time',
      StatementDate: 'Statement Date',
      StartDate: 'Start Date',
      EndDate: 'End Date',
      OrderID: 'Order ID',
      ParcelCode: 'Parcel Code',
      Bills: 'Bills',
      TableColumnParcelStatus: 'Parcel Status',
      TableColumnPaymentTime: 'Payment time',
      TableColumnDeliveryTime: 'Delivery Time',
      TableColumnStatementDate: 'Statement Date',
      NoRecord: 'No Record',
      SearchOptinsOrderID: 'Order ID',
      SearchOptinsParcelCode: 'Parcel Code',
      PackStatusPreparing: 'preparing',
      PackStatusCancelled: 'cancelled',
      PackStatusShipped: 'shipped',
      PackStatusCompleted: 'completed'
    }
  }
}
